import successIcon from '../../assets/svgs/imid-verification-success.svg';
import errorIcon from '../../assets/svgs/imid-verification-error.svg';
import CustomIcon from '../customIcon/CustomIcon';
import { cn } from '../../utils/cn';
import PageHeader from '../PageHeader';

interface VerificationResultCardProps {
    type: 'error' | 'success';
    title: React.ReactNode;
    description: React.ReactNode;
    contentClassName?: string;
    children?: React.ReactNode | React.ReactNode[];
}

const VerificationResultCard: React.FC<VerificationResultCardProps> = ({
    type,
    title,
    description,
    contentClassName = '',
    children,
}) => {
    return (
        <>
            <PageHeader
                title={title}
                lead={description}
                imgSrc={type === 'success' ? successIcon : errorIcon}
            />
            <div
                className={cn(
                    'flex flex-col gap-4 items-center w-full',
                    type === 'error' && "mt-auto md:mt-0",
                    contentClassName
                )}
            >
                {children}
            </div>
        </>
    );
};

export default VerificationResultCard;
